import React, { useEffect } from 'react'
import { useLocation, Switch, Route, Redirect } from 'react-router-dom'
import AdminNavbarAlternative from 'components/argon/Navbars/AdminNavbarAlternative.js'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import componentStyles from 'assets/theme/layouts/admin.js'
import SandboxLeads from 'scenes/tester/SandboxLeads'

const useStyles = makeStyles(componentStyles)

// Form testers (custom:account_type 'tester') only ever see the dev sandbox leads screen.
const Main = () => {
    const classes = useStyles()
    const location = useLocation()

    useEffect(() => {
        document.documentElement.scrollTop = 0
        document.scrollingElement.scrollTop = 0
    }, [location])

    return (
        <Box display='flex'>
            <Box position='relative' flex='1' className={classes.mainContent}>
                <AdminNavbarAlternative
                    accountType='tester'
                    name='Form Tester'
                />
                <Switch>
                    <Route exact path='/sandbox-leads' component={SandboxLeads} />
                    <Redirect from='*' to='/sandbox-leads' />
                </Switch>
            </Box>
        </Box>
    )
}

export default Main
